import TrashEventItem from "./trashEventItem.vue";
import { REQUEST_STATE, STATUS_CODE } from "@/enums";
import { MenuItemsService } from "@/services/menuItemsApi";

export default {
	components: { TrashEventItem },

	data() {
		return {
			data: null,
			state: REQUEST_STATE.LOADING,
			REQUEST_STATE,
		};
	},

	created() {
		this.loadData();
		this.$eventBus.$on("reloadComponentData", this.loadData);
	},

	beforeDestroy() {
		this.$eventBus.$off("reloadComponentData", this.loadData);
	},

	methods: { loadData },
};

async function loadData() {
	try {
		this.state = REQUEST_STATE.LOADING;

		const { data } = await MenuItemsService.getTrashEvents({ limit: 7 });
		this.data = data;

		this.state = REQUEST_STATE.SUCCESS;
	} catch (error) {
		if (error.response.status === STATUS_CODE.MISSING_DATA) this.state = REQUEST_STATE.MISSING_DATA;
	}
}
